module.exports = __webpack_public_path__ + "img/new-template.11e40cae.png";